import { MissedDealFeedbackIdleForm } from 'components/missed-deal-feedback/idle';
import { MissedDealFeedbackReadyForm } from 'components/missed-deal-feedback/ready';
import { MissedDealFeedbackSubmissionRequestedForm } from 'components/missed-deal-feedback/submission-requested';
import { MissedDealFeedbackSubmissionFailedForm } from 'components/missed-deal-feedback/sumission-failed';
import { useAppSelector } from 'hooks/useAppSelector';
import { FormIdProps } from 'shared/props';
import { getFeedbackStatus } from 'state/missed-deal-feeedback/selectors';

import { MissedDealFeedbackLoading } from './loading';
import { MissedDealFeedbackLoadingFailedForm } from './loading-failed';
import { MissedDealFeedbackSubmissionPending } from './pending';
import { MissedDealFeedbackSubmitted } from './submitted';

const Components = {
  Idle: MissedDealFeedbackIdleForm,
  Loading: MissedDealFeedbackLoading,
  LoadingFailed: MissedDealFeedbackLoadingFailedForm,
  SubmissionFailed: MissedDealFeedbackSubmissionFailedForm,
  ReadyForSubmission: MissedDealFeedbackReadyForm,
  SubmissionRequested: MissedDealFeedbackSubmissionRequestedForm,
  SubmissionPending: MissedDealFeedbackSubmissionPending,
  Submitted: MissedDealFeedbackSubmitted,
} as const;

export function MissedDealFeedback({ formId }: FormIdProps) {
  const status = useAppSelector(s => getFeedbackStatus(s, formId));
  const Component = Components[status];
  return <Component formId={formId} />;
}
